import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import * as Sentry from "@sentry/angular";
import * as AOS from "aos";
import "reflect-metadata";
import { AppModule } from "./app/main/app.module";
import { logger } from "./app/main/util/Logger";
import { environment } from "./environments/environment";

logger.info(`Starting Application. BuildId[${environment.buildId}]`);

if (environment.production) {
  enableProdMode();
}

if (environment.enableSentry) {
  Sentry.init({
    // Trace calls through to the API
    tracePropagationTargets: [environment.endpoint, "localhost"],
    dsn: "https://63ed20aa837e7c0ad25e739b8c2929a2@o4508741509971968.ingest.de.sentry.io/4508787963723856",
    environment: environment.sentryEnvironment,
    release: environment.buildId,
    normalizeDepth: 10, // capture deeper object properties
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: environment.sentryReplayMaskAllText,
        maskAllInputs: environment.sentryReplayMaskAllInputs,
        blockAllMedia: environment.sentryReplayBlockAllMedia,
        networkDetailAllowUrls: ["localhost", "api.dev.", "api.qa.", "api.uat.", "api.hub."],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: environment.sentryTracesSampleRate,
    // Session Replay
    replaysSessionSampleRate: environment.sentryReplaySessionSampleRate, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: environment.sentryReplayOnErrorSampleRate, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((ref) => {
    // Ensure Angular destroys itself on hot reloads.
    if (window["ngRef"]) {
      window["ngRef"].destroy();
    }
    window["ngRef"] = ref;

    // Otherwise, log the boot error
  })
  .catch((err) => console.error(err));

AOS.init();
